var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "event-modal faq-modal",
      attrs: {
        name: "addonsModal",
        width: "900px",
        height: "auto",
        scrollable: true
      }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("div", { staticClass: "modal-header-text" }, [
          _c("span", [_vm._v("ADD ONS AND POLICIES")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modal-close-img",
            on: {
              click: function($event) {
                _vm.hideModal()
              },
              mouseover: function($event) {
                _vm.isHoverClose = true
              },
              mouseleave: function($event) {
                _vm.isHoverClose = false
              }
            }
          },
          [
            !_vm.isHoverClose
              ? _c("img", {
                  attrs: {
                    src: require("../../../static/img/info-modal-close.svg"),
                    alt: "close"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isHoverClose
              ? _c("img", {
                  attrs: {
                    src: require("../../../static/img/info-modal-close-hover.svg"),
                    alt: "close"
                  }
                })
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("div", { staticClass: "faq-section" }, [
          _c("span", { staticClass: "modal-body-title" }, [
            _vm._v("What are Add Ons?")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "These are custom additions that are not included in our Standard Events. Please refer to your contract for billing details, as minimums and additional fees may apply."
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "faq-section" }, [
          _c("span", { staticClass: "modal-body-title" }, [
            _vm._v("Descriptions")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Venipuncture")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "By request ADURO will partner with a 3rd party vendor to provide onsite events utilizing the venipuncture method to collect the blood sample. The samples will be transported to an off-site laboratory for processing and results will be sent to ADURO to be uploaded into the platform. Participants will NOT receive a hard copy of their test results from the blood draw. Participants will receive a scorecard with their body composition results."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Cotinine")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "The iScreen OFD is an oral fluid screening test that can be included at an onsite event to screen for tobacco use. The staff will administer this test an obtain results within 10 minutes. The iScreen device detects up to 1- 2 days after nicotine use. These results will be entered the ConnectWell technology during the onsite event and transferred into the platform."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Well Being Assessment (WBA) Station")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "By request, ADURO can provide the optional WBA station occurs after the Program Concierge station. This prevents delays in screening event flow and helps maintain the 15-minute appointment timeline. The WBA is accessed inside of each participant’s platform account; therefore, the participants must be able to log into their account without assistance during the onsite event. It can take up to 20 minutes for a participant to complete the WBA.  For events with WBA stations, ADURO provides and set up a station with tablets. The station itself is unmanned and ADURO is unable to provide technical support."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Flu Shots")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "By request ADURO will partner with a 3rd party vendor to provide flu shots at an additional station"
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Paper Scheduler")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "The ADURO Event Manager will provide a “paper” appointment scheduler template for participants to sign up for a screening. The template will be created based on the number of expected participants and duration of event. each appointment is 15 minutes in length. The template cannot be altered without the approval of the Event Manager. It is the responsibility of the client to provide the completed schedule of appointments to the Event Lead on the day of event.  ADURO will be unable to provide appointment confirmations, reminders or participation reports when paper schedulers are used. An event cannot include a combination of paper and online registrations. Customers can either have a paper or online registration process per event."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Small Site Model")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "Onsite biometric screening events where ADURO will perform the following tests using the Finger Stick method; Total cholesterol, HDL, LDL, triglycerides and glucose and the following physical tests: blood pressure, heart rate and BMI (or equivalent body composition test).  The participant will leave with an unidentified scorecard with all their values. This service includes access to the online appointment scheduler, dedicated Event Manager and same day results transfer into the platform utilizing our ConnectWell technology.  For Small Site, one person (an Event Lead) is sent to the event to screen all participants, so the projected participation is limited to what one person can accomplish within 8 hours or less.  One person can screen 4 people per hour, with a max of 32 participants in 8 hours.  Any event can be Small Site as long as it meets these criteria."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Small Site Concierge")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "Program Concierge is not an included service with the Small Site model but can be purchased as a buy-up option, in which case we would send an additional person to run the Concierge station (two people total)."
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-424c45de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-424c45de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/AddonsModal.vue
// module id = 1444
// module chunks = 1